var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.index === 0)?_c('v-chip',{attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.item.name)+" ")]):_vm._e(),(_vm.index === 1)?_c('span',{staticClass:"green--text text-caption"},[_vm._v(" (+"+_vm._s(_vm.length - 1)+") ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }